import { Link, useNavigate } from "react-router-dom";
import { useLang, scrollToId } from "../App";
import { LOGOS } from "../images";
import { propertiesI18n } from "../i18n";

export default function Footer() {
  const { lang, t } = useLang();
  const navigate = useNavigate();
  const f = t.footer;

  const nav = [
    { id: "accueil", label: f.home, testid: "footer-nav-home" },
    { id: "expertise", label: t.nav.expertise, testid: "footer-nav-expertise" },
    { id: "approche", label: t.nav.about, testid: "footer-nav-about" },
    { id: "objekte", label: propertiesI18n[lang].navLabel, testid: "footer-nav-properties" },
    { id: "contact", label: t.nav.contact, testid: "footer-nav-contact" },
    { id: "espace", label: lang === "fr" ? "Espace membres" : lang === "de" ? "Member-Bereich" : "Member area", testid: "footer-nav-members" },
  ];

  const go = (id) => {
    if (id === "objekte") {
      navigate("/objekte");
      return;
    }
    if (id === "espace") {
      navigate("/espace");
      return;
    }
    scrollToId(id);
  };

  return (
    <footer data-testid="site-footer" className="bg-ink px-6 pb-10 pt-20 text-ivory md:px-12 lg:px-20">
      <div className="grid gap-14 md:grid-cols-3">
        <div>
          <img src={LOGOS.horizontalNegativ} alt="FLEN Immobilier" data-testid="footer-logo" className="h-9 w-auto" loading="lazy" />
        </div>
        <nav aria-label="Footer">
          <h3 className="text-[11px] font-medium uppercase tracking-[0.3em] text-champagne">{f.navTitle}</h3>
          <ul className="mt-6 space-y-3">
            {nav.map((n) => (
              <li key={n.id}>
                <button
                  data-testid={n.testid}
                  onClick={() => go(n.id)}
                  className="text-sm font-light text-ivory/70 transition-colors duration-300 hover:text-ivory"
                >
                  {n.label}
                </button>
              </li>
            ))}
          </ul>
        </nav>
        <div>
          <h3 className="text-[11px] font-medium uppercase tracking-[0.3em] text-champagne">{f.contactTitle}</h3>
          <ul className="mt-6 space-y-3 text-sm font-light text-ivory/70">
            <li>
              <a data-testid="footer-email" href={`mailto:${f.email}`} className="transition-colors duration-300 hover:text-ivory">{f.email}</a>
            </li>
            <li data-testid="footer-location">{f.location}</li>
          </ul>
        </div>
      </div>
      <div className="mt-20 flex flex-col gap-3 border-t border-ivory/10 pt-8 text-[12px] font-light text-ivory/40 md:flex-row md:items-center md:justify-between">
        <span data-testid="footer-rights">{f.rights}</span>
        <span className="flex flex-wrap gap-x-6 gap-y-2">
          <Link data-testid="footer-legal-mentions" to="/mentions-legales" className="transition-colors duration-300 hover:text-ivory">
            {f.legalMentions}
          </Link>
          <Link data-testid="footer-legal-privacy" to="/politique-de-confidentialite" className="transition-colors duration-300 hover:text-ivory">
            {f.legalPrivacy}
          </Link>
        </span>
      </div>
    </footer>
  );
}
